import { render, staticRenderFns } from "./CopyToClipboard.vue?vue&type=template&id=237aca32"
import script from "./CopyToClipboard.vue?vue&type=script&lang=js"
export * from "./CopyToClipboard.vue?vue&type=script&lang=js"
import style0 from "./CopyToClipboard.vue?vue&type=style&index=0&id=237aca32&prod&lang=scss"
import style1 from "./CopyToClipboard.vue?vue&type=style&index=1&id=237aca32&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports